import(/* webpackMode: "eager", webpackExports: ["LandingPageTemplate"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/templates/LandingPageTemplate/LandingPageTemplate.tsx");
